import Vue from 'vue'
import Vuetify from 'vuetify'
import es from 'vuetify/src/locale/es'
import en from '../locales/en'

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    locales: { en, es },
    current: 'en'
  },
  icons: {
    iconfont: 'mdi'
  }
})

/**
 *  Once this issue is fix https://github.com/yogakurniawan/vue-tel-input-vuetify/issues/2#issuecomment-643785884, put it back
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import es from 'vuetify/src/locale/es'
import en from '../locales/en'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#224177',
        secondary: '#EE9D32',
        accent: '#224177',
        //error: '#FF5252',
        //info: '#2196F3',
        //success: '#4CAF50',
        //warning: '#FFC107'
      }
    }
  },
  lang: {
    locales: { en, es },
    current: 'en'
  },
  icons: {
    iconfont: 'mdi'
  }
})
 */
